import { ResponseErrorHandling } from "../../../../helper";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

// Fireblocks
export const GetClientAvailableAssets = (client_id) => async (dispatch) => {
  try {
    const res = await commonService.get(`/client/crypto-management/assets-list/${client_id}`);
    const clientAvailableAssets = res.data.data;

    return clientAvailableAssets;
  } catch (err) {
    const message = err.response.data.message || err.message;

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
    return err.response.data;
  } 
};
